import { Component, OnInit, inject } from '@angular/core';

import { UserService } from '@core/auth/user.service';
import { BaseUserModel } from '@core/models/user-model';
import { BreadcrumbService } from '@core/services/breadcrumb.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  private breadcrumb = inject(BreadcrumbService);
  private userService = inject(UserService);

  loggedInUser: BaseUserModel | null = null;

  ngOnInit(): void {
    this.loggedInUser = this.userService.getUserFromLocalStorage();

    this.breadcrumb.setBreadcrumbs([
      {
        label: 'Dashboard',
        url: '/dashboard'
      }
    ]);
  }
}
